function guest(to, from, next) {
	const token = localStorage.getItem('@stup:token')
	if (token) {
		next('links')
	}
	return next()
}

export default guest
